import React from 'react';
import styles from './A_ProfileMenuSelectButton.module.css';
import cn from 'classnames';

interface A_ProfileMenuSelectButtonProps {
  icon: React.ReactNode;
  text: string;
  active?: boolean;
  onClick?: () => void;
  variant?: 'default' | 'mobile';
  balance?: number | null;
}

export default function A_ProfileMenuSelectButton({
  icon,
  text,
  active,
  onClick,
  variant = 'default',
  balance,
}: A_ProfileMenuSelectButtonProps) {
  return (
    <button
      className={cn(
        styles.wrapper,
        active && styles.active,
        variant === 'mobile' && styles.mobile
      )}
      onClick={onClick}
    >
      {icon}
      <div className={styles.content}>
        <span className={cn('text-p-8', styles.text)}>{text}</span>
        {balance !== undefined && (
          <span className={cn('text-p-8', styles.balance)}>
            {(balance ?? 0).toLocaleString('ru-RU')} $
          </span>
        )}
      </div>
    </button>
  );
}
